import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import type { QueryFunctionContext } from '@tanstack/react-query'
import { useInfiniteQuery } from '@tanstack/react-query'

export const useMembersInfiniteQuery = (searchQuery?: string) => {
  const limit = 10

  const membersInfiniteQuery = useInfiniteQuery({
    queryKey: ['membersInfinite', searchQuery],
    queryFn: async ({ pageParam = 1 }: QueryFunctionContext<any, number>) => {
      const { data } = await MembershipsCreatorApiClient.getMembers({
        limit,
        page: pageParam,
        search_query: searchQuery,
      })

      return data
    },
    enabled: !!(searchQuery && searchQuery.length > 2),
    getNextPageParam: ({ pagination }) => {
      if (pagination?.pages === pagination?.page) return

      return pagination && pagination.page + 1
    },
  })

  return { membersInfiniteQuery }
}
